import { createCachedSelector } from 're-reselect';
import { useQuery } from 'react-query';
import * as api from '../../services/api';
import { QUERY_CACHE_TIME } from '../../constants';
import useAccount from './useAccount';

const selector = createCachedSelector(
  (data) => data.data,
  (data, storeKey) => storeKey,
  (data) => {
    return { rankingBadges: data };
  }
)({
  keySelector: (data, storeKey) => storeKey
});

const useRankingBadges = () => {
  const { accountId } = useAccount();

  const storeKey = ['rankingBadges', accountId];
  const { isLoading, data } = useQuery(storeKey, async () => api.fetchRankingBadges({ accountId }), {
    enabled: !!accountId,
    select: (rankingBadgesData) => selector(rankingBadgesData, storeKey.join('#')),
    cacheTime: QUERY_CACHE_TIME
  });

  const { rankingBadges = {} } = data || {};

  return {
    isLoading,
    rankingBadges
  };
};

export default useRankingBadges;
